<template>
  <router-view></router-view>
</template>

<script>
export default {};
</script>

<style src="../public/css/main.css"></style>
